import { forwardRef } from 'react';

import { clsx } from 'clsx';

export type TabItemProps = {
    isActive?: boolean;
} & Omit<React.ComponentPropsWithRef<'button'>, 'className'>;

export const TabItem = forwardRef<HTMLButtonElement, TabItemProps>(
    ({ isActive, ...restProps }, ref) => {
        return (
            <button
                ref={ref}
                type="button"
                className={clsx(
                    [
                        'flex items-center gap-1 rounded-full p-2 text-xxs leading-[normal] focus:ring-0 focus:ring-offset-0',
                        'disabled:bg-icoGray-300 disabled:text-icoGray-400 dark:disabled:bg-white/5 dark:disabled:text-icoDarkMode-wolf'
                    ],
                    { 'bg-white dark:bg-icoDarkMode-deepBlack': !isActive },
                    { 'bg-icoBlue-100 text-icoBlue dark:bg-icoBlue dark:text-white': isActive }
                )}
                {...restProps}
            />
        );
    }
);

TabItem.displayName = 'TabItem';
